window.heromallar = {
  "heading": "Mallar för allt",
  "body": "Bläddra, välj, anpassa. Alla våra produkter har färdiga mallar som gör jobbet enklare.",
  "tabs": [
    {
       "name": "Klistermärken",
  "browse_all_url": "https://pressify.se/pages/editor",
  "design_mallar": [
    {
      "id": "mall_060",
      "title": "Scented Candles CO",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759948802/jpeg-optimizer_Sticker_1_ktom0o.png",
          "url": "/products/runda-klistermarken"
          },
    {
   

      "id": "mall_061",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759948802/jpeg-optimizer_Sticker_2_nkvmux.png",
      "url": "/products/runda-klistermarken"
              },
    {



            "id": "mall_021",
      "title": "Summer time living",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761064089/Sticker_32_xhyuav.png",
      "url": "/products/ovala-klistermarken"
    },
    {
 

      "id": "mall_063",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759948840/jpeg-optimizer_Sticker_4_flj1ci.png",
      "url": "/products/runda-klistermarken"
              },
    {



      "id": "mall_044",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759952072/jpeg-optimizer_Sticker_16_e6gfor.png",
      "url": "/products/kvadratiska-klistermarken"
              },
    {
                "id": "mall_046",
          "title": "Brazil",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759952071/jpeg-optimizer_Sticker_11_cath4l.png",
          "url": "/products/kvadratiska-klistermarken"
              },
    {



          "id": "mall_048",
          "title": "Color your life",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759952072/jpeg-optimizer_Sticker_14_rpafs5.png",
          "url": "/products/kvadratiska-klistermarken"
        },
        {


      "id": "mall_019",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759947630/jpeg-optimizer_Round_8_bvwlx3.png",
      "url": "/products/rektangulara-klistermarken"
              },
    {




     "id": "mall_019",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761064089/Sticker_33_aleyhd.png",
      "url": "/products/ovala-klistermarken"
              },
    {


      "id": "mall_056",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759947628/jpeg-optimizer_Round_6_ziwxki.png",
        "url": "/products/runda-klistermarken"
                    },
    {
            "id": "mall_068",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1760289983/jpeg-optimizer_Sticker_4_l8nelb.png",
        "url": "/products/runda-klistermarken"
                    },
    {
      "id": "mall_065",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759948841/jpeg-optimizer_Sticker_3_lnkxo5.png",
      "url": "/products/runda-klistermarken"
        }
      ]
    },
    {
       
"name": "Etiketter",
      "browse_all_url": "https://pressify.se/pages/editor",
      "design_mallar": [
        {
          "id": "mall_054",
          "title": "Rejuvenate",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759947626/jpeg-optimizer_Round_4_omuhzc.png",
          "url": "/products/rektangulara-etiketter-2"
        },
        {
          "id": "mall_056",
          "title": "Yasin's Pizza",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761927259/jpeg-optimizer_Sticker85_xvbcqy.png",
          "url": "/products/rektangulara-etiketter-2"
        },
        {

          "id": "mall_055",
          "title": "Avocado",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761927258/jpeg-optimizer_Sticker84_griiz3.png",
          "url": "/products/rektangulara-etiketter-2"
        },
        {
          "id": "mall_162",
          "title": "Italian Hazelnut",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759948086/tack_wxbn1w.png",
          "url": "/products/etiketter-pa-rulle-1"
        },
        {
          "id": "mall_043",
          "title": "Uppercut",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759949822/jpeg-optimizer_SQAURE_9_i0uly9.png",
          "url": "/products/kvadratiska-etiketter-1"
        },
        {
                    "id": "mall_054",
          "title": "Superbar",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761927258/jpeg-optimizer_Sticker83_incm3s.png",
          "url": "/products/rektangulara-etiketter-2"
        },
        {
          "id": "mall_180",
          "title": "Plant Power",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759949821/jpeg-optimizer_SQAURE_8_q4mfmm.png",
          "url": "/products/etiketter-pa-rulle-1"
              },
    {
      "id": "mall_057",
      "title": "CampCoffy",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761927258/jpeg-optimizer_Sticker86_mka7k5.png",
          "url": "/products/rektangulara-etiketter-2"
          },
    {
      "id": "mall_176",
      "title": "Bees & Bears",
      "subtitle": "Kvadratiska etiketter",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759949816/jpeg-optimizer_SQAURE_3_gknqgm.png",
          "url": "/products/etiketter-pa-rulle-1"
          },
    {
      "id": "mall_074",
      "title": "B&W",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748724204/a484462560fb87a43d7011399fea1909be_1_mzjjhi.jpg",
          "url": "/products/etiketter-pa-rulle-1"
          },
    {
          "id": "mall_164",
          "title": "Chill",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1759947627/jpeg-optimizer_Round_7_ebpsjg.png",
          "url": "/products/etiketter-pa-rulle-1"
        }
      ]
    },
    {
      "name": "Tackkort",
      "browse_all_url": "https://pressify.se/pages/editor",
      "design_mallar": [
        {
          "id": "mall_002",
          "title": "Paper flower",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125419/b49fa33bdea27d6fbb9512c4d639bb0d6c_2_f4vbzb.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_036",
          "title": "Red rose",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748955818/9faf4b96a91f7726b52771352d00771700_1_a8rhzh.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_042",
          "title": "Thank you enough",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748955819/7eb2eb0e1a8a726c6fc2467d9afb78ae22_1_z86fux.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_016",
          "title": "Stickers",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125690/4db3e80562c78fed66e7fa3bb042d6d6bd_2_ndpyz2.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_044",
          "title": "Smiley",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748955948/07085f45cc07e47c3b16b60f66c8730620_1_jrawrn.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_004",
          "title": "Merci",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125450/9f0fce017cdec87c72ecc97e4501065ed5_1_ivnvoz.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_029",
          "title": "Thank you",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746126439/803359b40c6d25b0b1f0615d75351ae0a1_1_cqbxpk.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_001",
          "title": "Pink dream",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125408/6eb4d4d1f4208d105362289695ec22395b_2_uyeqyc.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_039",
          "title": "New day",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748955819/b3d2169ae280a7fb39841d8207b6cdf239_1_ngyfsy.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_030",
          "title": "Cookie monster",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746126452/5f880631384cc51e1f8b92bb8a55efa7a7_1_iioicc.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_005",
          "title": "Cat",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125462/ba941664e1db76699e6cccc427419c3bc6_2_czku9r.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_031",
          "title": "Croissant",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748956107/dbdfe8fd4d74b4a3dcccc97aa3b696ad75_1_azf6gc.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_023",
          "title": "Los Angeles",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125787/9ed218f5c1650f146e007e408c6d65fc27_1_d46ueb.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_021",
          "title": "Dots",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125758/3eefc634ddd74904ef2f1e7491458d324e_1_cepyut.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_034",
          "title": "Retro",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748955818/87edb5e35ac3b0cdc277e9458911c99cb8_1_jgxuxi.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_037",
          "title": "Orange star",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748955818/bde7b7d47f3f2b855aae2ecb33b5fe7005_1_dxfcsy.jpg",
          "url": "/products/tackkort-1"
        },
        {
          "id": "mall_015",
          "title": "Hearts",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125678/211654aa224defe2f00e8c8cf243bb5a87_1_qqadtc.jpg",
          "url": "/products/tackkort-1"
    },
    {
      "id": "mall_014",
      "title": "Black line",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1746125667/8109644a451360bc37c276cc1a7a1ff769_1_oswflm.jpg",
          "url": "/products/tackkort-1"
        }
      ]
    },
    {
      "name": "Fraktpåsar",
      "browse_all_url": "https://pressify.se/pages/editor",
      "design_mallar": [
        {
          "id": "mall_0110",
          "title": "Your cool new clothing",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060570/jpeg-optimizer_Sticker_23_bu3h38.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0108",
          "title": "Teraluna",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060570/jpeg-optimizer_Sticker_29_gr9k5z.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0107",
          "title": "Wayplay",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060570/jpeg-optimizer_Sticker_21_rcrv0k.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0104",
          "title": "Nuvibes",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060569/jpeg-optimizer_Sticker_19_klxlvw.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0112",
          "title": "Superbar",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060571/jpeg-optimizer_Sticker_26_qdb78x.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0109",
          "title": "Ocha-Ocha",
                    "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060570/jpeg-optimizer_Sticker_25_dms6qc.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0106",
          "title": "Fifth",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060569/jpeg-optimizer_Sticker_27_mgmr8d.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0102",
          "title": "Honey",
          "subtitle": "Fraktpåse",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060569/jpeg-optimizer_Sticker_28_yc6otn.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0103",
          "title": "Coshi",
          "subtitle": "Fraktpåse",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060569/jpeg-optimizer_Sticker_22_aongui.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_009",
          "title": "Your order is here",
          "subtitle": "Fraktpåse",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1748792157/b2a2e47571bb239ee1004f3a6ace2eea5c_1_ndunsk.jpg",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0105",
          "title": "Method Coffee",
          "subtitle": "Fraktpåse",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060569/jpeg-optimizer_Sticker_20_rogvtx.png",
          "url": "/products/postpasar"
        },
        {
          "id": "mall_0111",
          "title": "I smell treats",
          "subtitle": "Fraktpåse",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761060571/jpeg-optimizer_Sticker_24_evo9sf.png",
          "url": "/products/postpasar"
        }
      ]
    },
    {
      "name": "Affischer",
      "browse_all_url": "https://pressify.se/pages/editor",
      "design_mallar": [
        {
          "id": "mall_008",
          "title": "Paper flower",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074259/salom321_utugxc.png",
          "url": "/products/posters-1"        },
        {
          "id": "mall_016",
          "title": "Red rose",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074257/bageri_nzpxzi.png",
          "url": "/products/posters-1"        },
        {
          "id": "mall_017",
          "title": "Thank you enough",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074257/b%C3%A4sta_pizzan321_zz4qsj.png",
          "url": "/products/posters-1"        },
        {
          "id": "mall_023",
          "title": "Stickers",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074258/art_kjqpsk.png",
          "url": "/products/posters-1"        },
    {
          "id": "mall_007",
          "title": "Merci",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074259/seolf-love_peqs9f.png",
          "url": "/products/posters-1"        },
        {
          "id": "mall_022",
          "title": "Thank you",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074256/cat_t8w8in.png",
          "url": "/products/tackkort-1"
        },
       
        {
          "id": "mall_018",
          "title": "Smiley",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074257/specialrabtat_ovyho4.png",
          "url": "/products/posters-1"        },
        {

          "id": "mall_006",
          "title": "New day",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1752584058/4bcc0c6415eb097eed28f8323958bf5cac_1_kqoxry.jpg",
          "url": "/products/posters-1"        },
        {
          "id": "mall_011",
          "title": "Cookie monster",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074259/nytt_event_sillgm.png",
          "url": "/products/posters-1"        },
        {
          "id": "mall_021",
          "title": "Cat",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074257/black_friday_rjvrwd.png",
          "url": "/products/posters-1"        },
        {
          "id": "mall_015",
          "title": "Croissant",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761074257/morgonfika_gqmikr.png",
          "url": "/products/posters-1"        },
        {
     
          "id": "mall_005",
          "title": "Dots",
          "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1752584072/118467f58f96639275f49149d5e7c6abc4_1_joqaqp.jpg",
          "url": "/products/posters-1"

        }
      ]
    },
    {
      "name": "Packtejp",
      "browse_all_url": "https://pressify.se/pages/editor",
      "design_mallar": [
       {
      "id": "mall_014",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761852185/Sticker73_jryaoo.png",
      "url": "/products/packtejp-1"
    },
    {
      "id": "mall_017",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761852184/Sticker76_nw1yjp.png",
      "url": "/products/packtejp-1"
    },
    {
      "id": "mall_016",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761852184/Sticker75_vndhfa.png",
      "url": "/products/packtejp-1"
    },
    {
      "id": "mall_015",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761852185/Sticker74_iptjda.png",
      "url": "/products/packtejp-1"
    },
    {
      "id": "mall_019",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761852184/Sticker80_xofpi3.png",
      "url": "/products/packtejp-1"
    },
    {
      "id": "mall_005",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1755532400/77f13a70100bd35ec44ab35d1a5e04a912_1_b5worh.jpg",
      "url": "/products/packtejp-1"
    },
    {
      "id": "mall_004",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1755532335/d915927ded1b97e6d31ee25c90aca2dae2_1_svi218.jpg",
      "url": "/products/packtejp-1"
    },
    {
      "id": "mall_003",
      "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1755532350/c1a78cf38bf5d5673e9eff4f9fd49d4d6b_1_mdf7ym.jpg",
      "url": "/products/packtejp-1"
    },
    {
      "id": "mall_012",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1755532403/ba9977ce0d5ff896f51dc74c402c58219e_1_tprcgu.jpg",
      "url": "/products/packtejp-1"
          },
    {
      "id": "mall_010",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1755532275/25d1d0239da742627452490e912e0e83c9_1_bahvus.jpg",
      "url": "/products/packtejp-1"
       },
    {
      "id": "mall_011",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1755532321/d2d7e1fad363c861ed84ebcac0eeed73b2_1_yp59cq.jpg",
      "url": "/products/packtejp-1"
       },
    {
      "id": "mall_008",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1755532297/ab02126f273d71cc4f0e6af2ce94dbde36_1_yzat9q.jpg",
      "url": "/products/packtejp-1"
       },
    {
      "id": "mall_009",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1758720984/dee033ff9cd457cb9fb9af25db9e76b4f1_1_vhvho5.jpg",
      "url": "/products/packtejp-1"
             },
    {
      "id": "mall_002",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1758720817/706ec51efccc0712b253db833b8117b5b2_1_uxafi7.jpg",
      "url": "/products/packtejp-1"
       },
    {
      "id": "mall_006",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1758720901/568ead50a548b830cc0548668a7ae90526_1_pb7xzr.png",
      "url": "/products/packtejp-1"
       },
    {
      "id": "mall_018",
            "title": "x",
      "previewImage": "https://res.cloudinary.com/dmgmoisae/image/upload/v1761852184/Sticker79_jr8ea5.png",
      "url": "/products/packtejp-1"
        }
      ]
    },
    // ---- Lägg till fler tabbar här vid behov ----
  ]
};